// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-register__flex[data-v-6608fd26]{padding:8px 8px 0}.w-register__flex--email[data-v-6608fd26]{margin-bottom:12px}.w-register__flex--actions[data-v-6608fd26]{margin-top:36px}", ""]);
// Exports
module.exports = exports;
